import { createAction } from "@ngrx/store";

export const initializedWithToken = createAction(
  'App.InitializedWithToken'
);
